import { render, staticRenderFns } from "./FileUploadManager.vue?vue&type=template&id=dd973c64&scoped=true"
import script from "./FileUploadManager.vue?vue&type=script&lang=js"
export * from "./FileUploadManager.vue?vue&type=script&lang=js"
import style0 from "./FileUploadManager.vue?vue&type=style&index=0&id=dd973c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd973c64",
  null
  
)

export default component.exports